import { writable } from 'svelte/store';

let siteText            = 'São Pedro Imóveis';
let siteDescription     = 'Imobiliária - Porto Alegre - RS';

export let tagsSEO      = writable('Administração de Condomínios,<br class="hidden-sm hidden-xs"> Aluguel, Compra e Venda de Imóveis,<br class="hidden-sm hidden-xs"> em Porto Alegre - RS.');

export const alt				= writable(siteText);
export const headerTitleHome	= writable(siteText + " | " + siteDescription);
export const headerTitle		= writable("| " + siteText);
export const textSite			= writable(siteText);

export const ntRent			= writable('1');
export const ntSeason		= writable('0');
export const ntSell			= writable('3');

// E-mails
export const mailAtendimento	= writable("siteatendimento@saopedroimoveis.com.br");
export const mailLocacao		= writable("sitelocacao@saopedroimoveis.com.br");
export const mailVendas			= writable("sitevendas@saopedroimoveis.com.br");
export const mailOuvidoria		= writable("siteouvidoria@saopedroimoveis.com.br");
export const mailRH				= writable("siterh@saopedroimoveis.com.br");
export const mailLista			= writable("sitelista@saopedroimoveis.com.br");
export const mailAtualize		= writable("siteatendimento@saopedroimoveis.com.br");
export const mailCadastro		= writable("sitecadastro@saopedroimoveis.com.br");
export const mailCondominios	= writable("sitecondominios@saopedroimoveis.com.br");
export const mailProposta		= writable("siteproposta@saopedroimoveis.com.br");

export const textTelefoneVendas		= writable("(51) 3022-8621");
export const linkTelefoneVendas		= writable("https://wa.me/555130228621");

export const textTelefoneLocacao	= writable("(51) 3022-8621");
export const linkTelefoneLocacao	= writable("https://wa.me/555130228621");

export const textTelefoneCondominio	= writable("(51) 3022-8621");
export const linkTelefoneCondominio	= writable("https://wa.me/555130228621");

export const whatsappVendas			= writable("5551993710739");
export const textWhatsappVendas		= writable("(51) 99371-0739");
export const linkWhatsappVendas		= writable("https://wa.me/5551993710739");

export const whatsappLocacao		= writable("555130228621");
export const textWhatsappLocacao	= writable("(51) 3022-8621");
export const linkWhatsappLocacao	= writable("https://wa.me/555130228621");

export const whatsappCondominio		= writable("555130228621");
export const textWhatsappCondominio	= writable("(51) 3022-8621");
export const linkWhatsappCondominio	= writable("https://wa.me/555130228621");

// Links
export const linkPesquisaVendas		= writable("/imoveis/vendas#tipo_negociacao=3");
export const linkPesquisaLocacao	= writable("/imoveis/locacao#tipo_negociacao=1");

// Redes Sociais e Atendimento
export const linkFacebook       = writable("");
export const linkInstagram      = writable("");
export const linkYoutube        = writable("");
export const linkTwitter        = writable("");
export const linkBlog	        = writable("");

export const linkMapa           = writable("https://goo.gl/maps/2u3k4UN5Yf3bAfui6");
export const linkWaze           = writable("https://ul.waze.com/ul?place=ChIJncWquV54GZURfQBWgXvTigk&ll=-30.05236220%2C-51.21716600&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location");
export const linkUber           = writable("https://m.uber.com/ul/?action=setPickup&client_id=mJFI69a4nv1uaEYn1FxaazL2STBfVFIO&pickup=my_location&dropoff[formatted_address]=S%C3%A3o%20Pedro%20Administradora%20de%20Im%C3%B3veis%20-%20Rua%20Bar%C3%A3o%20do%20Triunfo%20-%20Azenha%2C%20Porto%20Alegre%20-%20RS%2C%20Brasil&dropoff[latitude]=-30.052362&dropoff[longitude]=-51.217166");
export const linkIframeMapa     = writable("https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3453.4596086795677!2d-51.21935468429414!3d-30.05235753860658!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9519785eb9aac59d%3A0x98ad37b8156007d!2sS%C3%A3o%20Pedro%20Administradora%20de%20Im%C3%B3veis!5e0!3m2!1spt-BR!2sbr!4v1663010775226!5m2!1spt-BR!2sbr");

export const linkAPI            = writable("http://www.api.com.br");
export const linkAV             = writable("https://appsaopedroimoveis.com.br/saopedro/dashboard");
export const linkConheca        = writable("https://appsaopedroimoveis.com.br/siteav/");
export const linkSolicite       = writable("https://appsaopedroimoveis.com.br/saopedro/login?help=1");
export const linkBoletoFacil    = writable("https://appsaopedroimoveis.com.br/saopedro/login?boleto-facil=1");

export const textAtendimento            = writable('De Segunda à Sexta,<br class="hidden-sm hidden-xs"/> das 9h às 12h e das 13h às 17h.<br class="hidden-sm hidden-xs"/> Plantão de Vendas,<br class="hidden-sm hidden-xs"/> agendar pelo telefone.');
export const textEndereco               = writable('Rua Barão do Triunfo, 454,<br class="hidden-sm hidden-xs"/> Azenha, Porto Alegre - RS');
export const textCNPJ                   = writable("07.233.100/0001-07");
export const textCreci                  = writable("23357");

export const linkPoliticaPrivacidade	= writable("/assets/files/PoliticaDePrivacidade.pdf");
export const linkPoliticaCookies		= writable("/assets/files/PoliticaDePrivacidade.pdf");

export const textPoliticaCheck 			= writable("Aceito compartilhar meus dados de acordo com a <a href='/assets/files/PoliticaDePrivacidade.pdf' target='_blank'>Política de Privacidade</a> da São Pedro Imóveis. Estou ciente e concordo em receber todas as comunicações relativas ao meu cadastro, incluindo comunicados, informações e promoções.");

export const todosContatos = writable([
	{
		title: 'Atendimento Geral',
		icon: '<i class="fab fa-whatsapp"></i>',
		href: 'https://wa.me/555130228621',
		target: '_blank',
		phone: '(51) 3022-8621',
		email: 'siteatendimento@saopedroimoveis.com.br'
	},
	{
		title: 'Atendimento Geral',
		icon: '<i class="fas fa-phone"></i>',
		href: 'tel:+555130228635',
		target: '_blank',
		phone: '(51) 3022-8635',
		email: 'siteatendimento@saopedroimoveis.com.br'
	},
	{
		title: 'Atendimento Geral',
		icon: '<i class="fas fa-phone"></i>',
		href: 'tel:+555130228642',
		target: '_blank',
		phone: '(51) 3022-8642',
		email: 'siteatendimento@saopedroimoveis.com.br'
	},
]);

export const propostaContatos = writable([
	{
		title: 'Atendimento Geral',
		icon: '<i class="fab fa-whatsapp"></i>',
		href: 'https://wa.me/555130228621',
		target: '_blank',
		phone: '(51) 3022-8621',
		email: 'siteproposta@appsaopedroimoveis.com.br'
	},
	{
		title: 'Atendimento Geral',
		icon: '<i class="fas fa-phone"></i>',
		href: 'tel:+555130228635',
		target: '_blank',
		phone: '(51) 3022-8635',
		email: 'siteproposta@appsaopedroimoveis.com.br'
	},
	{
		title: 'Atendimento Geral',
		icon: '<i class="fas fa-phone"></i>',
		href: 'tel:+555130228642',
		target: '_blank',
		phone: '(51) 3022-8642',
		email: 'siteproposta@appsaopedroimoveis.com.br'
	},
]);

export const comoChegar = writable([
	{
		title: 'Mapa',
		icon: '<i class="fas fa-map-marked-alt color-accent"></i>',
		link: 'https://goo.gl/maps/2u3k4UN5Yf3bAfui6',
	},
	{
		title: 'Waze',
		icon: '<i class="fab fa-waze color-accent"></i>',
		link: 'https://ul.waze.com/ul?place=ChIJncWquV54GZURfQBWgXvTigk&ll=-30.05236220%2C-51.21716600&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location',
	},
	{
		title: 'Uber',
		icon: '<i class="fab fa-uber color-accent"></i>',
		link: 'https://m.uber.com/ul/?action=setPickup&client_id=mJFI69a4nv1uaEYn1FxaazL2STBfVFIO&pickup=my_location&dropoff[formatted_address]=S%C3%A3o%20Pedro%20Administradora%20de%20Im%C3%B3veis%20-%20Rua%20Bar%C3%A3o%20do%20Triunfo%20-%20Azenha%2C%20Porto%20Alegre%20-%20RS%2C%20Brasil&dropoff[latitude]=-30.052362&dropoff[longitude]=-51.217166',
	}
]);